export function factoryCommandError(code: string) {
  if (code === 'stock_source_successor_hold')
    return 'พักคำสั่งนี้: ต้นทาง stock มีฉบับส่งใหม่ · ให้ R&D ที่มีสิทธิ์เทคนิคทั้งสองโครงการตรวจต้นทางและทบทวนสเปกที่เชื่อมอีกครั้ง';
  if (code === 'stock_source_review_required')
    return 'พักคำสั่งนี้: ผลทบทวนหรือสิทธิ์ผู้ทบทวนต้นทาง stock ใช้ไม่ได้แล้ว · ให้ผู้มีสิทธิ์เทคนิคทั้งสองโครงการตรวจและทบทวนใหม่';
  return 'ยังบันทึกไม่ได้ · ตรวจฉบับ หลักฐาน จำนวน และสิทธิ์ปัจจุบัน';
}
